module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "commandContainer"
    }
  }, [_c('bouton', {
    attrs: {
      "className": "button-refresh",
      "text": "Refresh"
    },
    on: {
      "click": _vm.refresh
    }
  }), _vm._v(" "), _c('bouton', {
    attrs: {
      "className": "button-refresh-automatic",
      "text": "Start Refresh Automatic"
    },
    on: {
      "click": _vm.refreshAutomatic
    }
  }), _vm._v(" "), _c('bouton', {
    attrs: {
      "className": "button-stop",
      "text": "Stop refresh Automatic"
    },
    on: {
      "click": _vm.stopRefreshAutomatic
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-09e1983c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CommandContainer/CommandContainer.vue
// module id = 23
// module chunks = 1